

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AppComponent } from './app.component';



// Import containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent
]

/// Import components
import {
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
} from './components';

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
]

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
} from './directives';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
]

// Import routing module
import { AppRoutingModule } from './app.routing';

import { FormsModule, ReactiveFormsModule, Validators, FormBuilder } from '@angular/forms';


// Import 3rd party components
import { ToasterModule } from 'angular2-toaster';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { BsDropdownModule } from 'ngx-bootstrap';
import { AuthGuard } from 'app/account/auth.guard';
import { AuthService } from 'app/account/auth.service';
import { AccountModule } from 'app/account/account.module';
//import { AdminModule } from 'app/admin/admin.module';
import { BaseService } from 'app/services/base.service';
import { AlertService } from 'app/services/alert.service';
import { AlertComponent } from 'app/alert/alert.component';
import { NascarService } from 'app/services/nascar.service';
import { NascarComponent } from './nascar/nascar.component';
import { GenericFilterPipe } from './pipes/generic.filter.pipe';
import { GenericSortPipe } from 'app/pipes/generic.sort.pipe';
import { NascarResultsComponent } from './nascarresults/nascarresults.component';
import { NflComponent } from './nfl/nfl.component';
import { NflResultsComponent } from './nflresults/nflresults.component';
import { SpreadManagerComponent } from './nflmanager/spread-manager/spread-manager.component';
import { NflService } from 'app/services/nfl.service';
import { UserManagerComponent } from './nflmanager/usermanager/usermanager.component';
import { AppOrgSeasonWeekComponent } from './app-orgseasonweek/app-orgseasonweek.component';
import { OrgSeasonWeekService } from './services/orgseasonweek.service';
import { AdminService } from './services/admin.service';
import { OrgService } from './services/org.service';
import { UserService } from './services/user.service';
import { RoleService } from './services/role.service';
import { OddsService } from './services/odds.service';


import { CreateRaceComponent } from './admin/nascar/createrace/createrace.component';
//import { OrgsComponent } from './admin/orgs/orgs.component';
import { DataFilterPipe } from './pipes/datafilter.pipe';
import { SearchPipe } from './pipes/search.pipe';

import { DataTableModule } from 'angular2-datatable';
import { GamesComponent } from './admin/nfl/games/games.component';
import { ManageRacesComponent } from './admin/nascar/manageraces/manageraces.component';
import { ManageUserDriversComponent } from './admin/nascar/manageuserdrivers/manageuserdrivers.component';
import { AddOrgComponent } from './org/add-org/add-org.component';
import { CreateOrgComponent } from './admin/org/create-org/create-org.component';
import { ListOrgComponent } from './admin/org/list-org/list-org.component';
import { ListUserComponent } from './admin/user/list-user/list-user.component';
import { SendComponent } from './admin/email/send/send.component';
import { RolelistComponent } from './admin/role/rolelist/rolelist.component';
import { BuyComponent } from './buy/buy.component';


//import { ManageracesComponent } from './manageraces/manageraces.component';


@NgModule({
  imports: [
    ToasterModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    ChartsModule,
    AccountModule,
    DataTableModule,
    TabsModule.forRoot()

  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
    AlertComponent,
    NascarComponent,
    GenericFilterPipe,
    GenericSortPipe,
    NascarResultsComponent,
    NflComponent,
    NflResultsComponent,
    SpreadManagerComponent,
    UserManagerComponent,
    AppOrgSeasonWeekComponent,
    CreateRaceComponent,
    DataFilterPipe,
    SearchPipe,
    GamesComponent,
    ManageRacesComponent,
    ManageUserDriversComponent,
  // OrgsComponent,
    AddOrgComponent,
    CreateOrgComponent,
    ListOrgComponent,
    ListUserComponent,
    SendComponent,
    RolelistComponent,
    BuyComponent

  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
  },  BaseService,
      AuthGuard,
      AuthService,
      AlertService,
      NascarService,
      NflService,
      OrgSeasonWeekService,
      AdminService,
      OrgService,
      UserService,
      RoleService,
      OddsService],
  bootstrap: [AppComponent]
})
export class AppModule { }





// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/app.module.ts